import React from "react";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import PropTypes from "prop-types";

const useStyles = makeStyles({
	button: {
		margin: "0 2px",
		minWidth: "38px",
		minHeight: "30px",
		padding: "0",
	},
	menuItem: {
		padding: "0 16px",
		minHeight: "30px",
	},
});

const StyledMenu = styled(Menu)({
	"& .MuiPaper-root": {
		border: "1px solid #d3d4d5",
	},
	"& .MuiList-root": {
		padding: "0",
	},
});

const MoreActionsMenu = (props) => {
	const { actions } = props;
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<Button
				aria-controls="more-actions-menu"
				aria-haspopup="true"
				variant="outlined"
				color="primary"
				onClick={handleClick}
				size="small"
				className={classes.button}
			>
				<MoreHorizIcon fontSize="small" />
			</Button>
			<StyledMenu
				id="more-actions-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				elevation={0}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
			>
				{actions?.map((a, idx) => (
					<MenuItem className={classes.menuItem} key={idx}>
						<ListItemText
							primary={a.displayName}
							onClick={() => {
								setAnchorEl(null);
								a.function();
							}}
						/>
					</MenuItem>
				))}
			</StyledMenu>
		</>
	);
};

MoreActionsMenu.propTypes = {
	actions: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			type: PropTypes.string,
			displayName: PropTypes.string,
			function: PropTypes.func,
		})
	).isRequired,
};

export default MoreActionsMenu;
